'use client';

import { useObservable } from '@legendapp/state/react';
import { $React } from '@legendapp/state/react-web';
import { type FormEvent, useState } from 'react';
import { Typography } from '@/components/Typography';
import type { CmsSiteConfig } from '@/services/cms-sdk';

export type SubscribeProps = Pick<CmsSiteConfig, 'subscribeButtonLabel' | 'subscribeFormTitle' | 'subscribeFormUrl'>;
export type SubscribeFormProps = Omit<SubscribeProps, 'subscribeFormTitle'>;

export function SubscribeForm({ subscribeButtonLabel, subscribeFormUrl }: SubscribeFormProps) {
    const email$ = useObservable('');
    const [submitted, setSubmitted] = useState(false);
    const onSubmit = (event: FormEvent) => {
        event.preventDefault();
        const redirectUrl = new URL(subscribeFormUrl || '');
        redirectUrl.searchParams.append('MERGE0', email$.get());
        setSubmitted(true);
        window.open(redirectUrl.toString(), '_blank');
    };

    email$.onChange(() => {
        setSubmitted(false);
    });

    if (!subscribeFormUrl) {
        return null;
    }

    const subscribeLabel = subscribeButtonLabel ? subscribeButtonLabel : 'Subscribe';

    return (
        <form onSubmit={onSubmit}>
            <div className="join bg-white rounded-box p-1 pl-[20px] w-full">
                <label className="join-item flex-grow-1">
                    <$React.input
                        className="input border-white focus:outline-0 !shadow-none text-base-content px-0 my-1 placeholder-current"
                        name="newsletter-email"
                        placeholder="Email address"
                        required
                        type="email"
                        $value={email$}
                    />
                </label>
                <div className="join-item ml-2">
                    <button className="btn btn-primary px-6 md:px-12 py-6 text-white" type="submit">
                        {submitted ? 'Submitted!' : subscribeLabel}
                    </button>
                </div>
            </div>
        </form>
    );
}

export function Subscribe({ subscribeButtonLabel, subscribeFormTitle, subscribeFormUrl }: SubscribeProps) {
    if (!subscribeFormUrl) {
        return null;
    }

    return (
        <div className="flex flex-col md:flex-row justify-between">
            <div className="max-w-[600px]">
                {subscribeFormTitle !== undefined ? (
                    <Typography as="div" variant="h2" className="font-bolden-van text-[32px] md:text-[40px] md:w-[430px] leading-16">
                        {subscribeFormTitle}
                    </Typography>
                ) : null}
            </div>
            <div className="max-w-[600px] flex-grow-1 mt-8 md:mt-9">
                <SubscribeForm subscribeButtonLabel={subscribeButtonLabel} subscribeFormUrl={subscribeFormUrl} />
            </div>
        </div>
    );
}
